export default __webpack_public_path__ + "static/media/logo-zona-azul.a31c5b9d.png";